// extracted by mini-css-extract-plugin
export default {"content":"BalanceBlock_content__y4k+L","title":"BalanceBlock_title__y2YJ2","checkbox":"BalanceBlock_checkbox__XgPup","checkbox_text":"BalanceBlock_checkbox_text__SJt15"};